<template>
  <v-autocomplete
    v-model="selected"
    :items="fullList"
    :loading="isLoading"
    item-value="id"
    item-text="name"
    :label="label"
    :placeholder="placeholder"
    no-data-text="По вашему запросу ничего не найдено"
    return-object
  />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'v-searchable-category-select',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Выберите категорию',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    placeholder: {
      type: String,
      default: 'Введите запрос или выберите категорию из списка',
    },
  },
  data: () => ({
    isLoading: false,
    query: null,
    lastQuery: null,
    selected: null,
  }),
  computed: {
    ...mapState('categories', ['fullList']),
  },
  watch: {
    query(value) {
      this.debouncedSearch(value);
    },
    selected(value) {
      this.$emit('change', value);
    },
    data: {
      immediate: true,
      handler(value) {
        this.selected = { ...value };
      },
    },
  },
  async created() {
    await this.getFullList();
  },
  methods: {
    ...mapActions('categories', ['getFullList']),

    async search(query) {
      this.lastQuery = query;

      if (!query) {
        await this.getList();
        this.isLoading = false;
        return;
      }

      if (query.length < 3) return;

      try {
        await this.getList({ query });
      } catch (e) {
        console.warn(e);
      }

      this.isLoading = false;

      if (this.lastQuery !== query) {
        this.search(query);
      }
    },
  },
};
</script>
